import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "../../../SharedComponents/Button/Button";
import "./LoginRequestPasswordResetSuccess.css";

export const LoginRequestPasswordResetSuccess = ({ email }) => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <div className="LoginRequestPasswordResetSuccess">
      <div className="LoginRequestPasswordResetSuccess__text">
        {t("success.emailSentToAccount", {
          email,
        })}
      </div>

      <div className="LoginRequestPasswordResetSuccess__button">
        <Button
          buttonStyle="Button__primary"
          click={() => history.push("/login")}
        >
          {t("loginForm.backToLogin")}
        </Button>
      </div>
    </div>
  );
};
